import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import LoadingSpinnerModal from "../../Components/LoadingSpinnerModal";
import ActionNotifications from "../../Components/ActionNotifications";
import useFetch from "../../Hooks/useFetch";
import ProgressBar from "./Components/progressBar";
import InfoTab from "./Components/infoTab";
import { getUserId } from "../../Utils/helper";
import { Button } from "devextreme-react/button";

import DenyPurchaseOrders from "../../Components/DenyOrders/denyPurchaseOrders";

function Details(props) {
  const navigate = useNavigate();
  const fetch = useFetch(navigate);

  const poDetail = props?.data?.data;
  const [response, setResponse] = useState([]);
  const isUserKristen = getUserId() === "d4ec0560-d7b0-4385-81a3-ef5ac53df4da";

  const [showPopup, setPopup] = useState({
    poDeny: null,
  });

  const handleClose = (popupKey) => {
    setPopup((prev) => ({ ...prev, [popupKey]: null }));
  };

  const handlePopup = useCallback((popupKey, data) => {
    setPopup((prev) => ({ ...prev, [popupKey]: { data } }));
  }, []);

  const fetchSuccessful = (resp) => {
    setResponse(resp);
    return (
      resp?.success &&
      resp?.data?.statusCode &&
      resp?.success !== "Invalid Model"
    );
  };

  return (
    <>
      <ActionNotifications response={response} />

      {/* ✅ Deny popup (same pattern as Orders) */}
      {showPopup.poDeny && (
        <DenyPurchaseOrders
          orderId={showPopup.poDeny.data}
          setNotifications={(n) => setResponse(n)}
          onClose={() => handleClose("poDeny")}
          mutate={props?.mutate}
          fetch={fetch}
        />
      )}

      {/* ✅ Deny button right above ProgressBar */}
      <div className="div-button">
        <Button
          id="deny-button"
          type="danger"
          text="Deny"
          onClick={() => handlePopup("poDeny", poDetail?.id)}
          visible={poDetail?.poStatus !== 10 && isUserKristen}
        />
      </div>

      <ProgressBar
        type={"PO"}
        order={poDetail}
        fetch={fetch}
        fetchSuccessful={fetchSuccessful}
      />

      <InfoTab
        poDetail={poDetail}
        isUserKristen={isUserKristen}
        fetchSuccessful={fetchSuccessful}
      />
    </>
  );
}

export default Details;
